import { io } from "socket.io-client";

const SOCKET = process.env.REACT_APP_SOCKET_PORT;

const Socket = io(`${SOCKET}`, {
  transports: [`websocket`],
  withCredentials: true,
});

export default Socket;